// extracted by mini-css-extract-plugin
export default {"invoiceCell":"_2uZTbaWm1oghY3n-8l7vjr","statusPanelWrapper":"_3rKZEuHy9H0iM7tPuBGnYv"};